import * as React from 'react';

import { Box, Divider, Stack, Typography } from '@mui/material';

import { transformToUtcTime } from '../core/textTransforms';

interface FlightSegmentTimesStackProps {
  pushTime?: string | null;
  outTime?: string | null;
  offTime?: string | null;
  onTime?: string | null;
  inTime?: string | null;
}

function FlightSegmentTimesStack({
  pushTime,
  outTime,
  offTime,
  onTime,
  inTime,
}: FlightSegmentTimesStackProps) {
  return (
    <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
      <Box>
        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>PUSH: </Typography>
        <Typography variant="body2" component="span">{transformToUtcTime(pushTime)}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>OUT: </Typography>
        <Typography variant="body2" component="span">{transformToUtcTime(outTime)}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>OFF: </Typography>
        <Typography variant="body2" component="span">{transformToUtcTime(offTime)}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>ON: </Typography>
        <Typography variant="body2" component="span">{transformToUtcTime(onTime)}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>IN: </Typography>
        <Typography variant="body2" component="span">{transformToUtcTime(inTime)}</Typography>
      </Box>
    </Stack>
  );
}

export default FlightSegmentTimesStack;
